export default __webpack_public_path__ + "static/media/vFlow_Logo_dark.c9f3fcef.svg";